import { Anchor } from "@mantine/core";
import React from "react";

interface TitleCellProps {
  row: {
    id?: string | number;
    text?: string;
  };
}

const TitleCell: React.FC<TitleCellProps> = ({ row }) => {
  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();

    const base = window.location.href.split("?")[0];
    const id = row?.id;

    if (!id) return;

    window.location.href = `${base}?id=${id}`;
  };

  return (
    <div className="gantt-title-cell">
      <Anchor fw={500} onClick={handleClick}>
        {row?.text}
      </Anchor>
    </div>
  );
};

export default TitleCell;
